<template>
    <div>
        <vue-headful :title="$t('students-list')" />
        <!-- Инфа с цветами -->
        <div class="vx-col w-full flex sm:items-center sm:flex-row flex-col ml-3">
            <div v-if="courseInfo" class="flex flex-wrap">
                <vs-chip v-if="courseInfo.discipline" color="primary" transparent>
                    ({{ courseInfo.discipline.courseid }}) {{ courseInfo.discipline.courseabbreviation }}
                </vs-chip>
                <vs-chip v-if="courseInfo.discipline" color="primary" transparent>
                    {{ courseInfo.discipline.name }}
                </vs-chip>
                <vs-chip color="primary" transparent>
                    {{ courseInfo.language }}
                </vs-chip>
                <vs-chip color="primary" transparent>
                    {{$t('Section')}} {{ courseInfo.flux.number_of_times_per_week }}
                </vs-chip>
                <vs-chip color="primary" transparent>
                    {{ courseInfo.load_type }}
                </vs-chip>
                <vs-chip color="primary" transparent v-if="courseInfo.room">
                    {{ courseInfo.room.name }}
                </vs-chip>
                <vs-chip color="primary" transparent v-if="courseInfo.teacher">
                    {{ courseInfo.teacher.full_name }}
                </vs-chip>
                <vs-chip color="primary" transparent v-if="courseInfo.course_status">
                    {{ courseInfo.course_status.name }}
                </vs-chip>
                <vs-chip color="primary" transparent v-if="courseInfo.flux">
                    {{ courseInfo.flux.training_format ? courseInfo.flux.training_format.name  : ''}}
                </vs-chip>
                <vs-chip color="primary" transparent v-if="courseInfo.day_week">
                    {{ courseInfo.day_week.name }}
                </vs-chip>
                <vs-chip color="primary" transparent>
                    {{ courseInfo.from_time }}
                </vs-chip>
            </div>
        </div>

        <vs-button
            @click="$router.go(-1)"
            size="small"
            type="border"
            class="my-2 mx-2"
        >
            {{ $t("return_back") }}
        </vs-button>
        <vs-tabs alignment="fixed">
            <vs-tab :label="$t('Applications')">
                <StudentsTable :listStudents="listStudents" @goToProfile="goToProfile"></StudentsTable>
            </vs-tab>
            <vs-tab :label="$t('waiting_list')" v-if="useNotificationList">
                <StudentsTable :listStudents="notificationListStudents" @goToProfile="goToProfile"></StudentsTable>
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
import StudentsTable from "@/pages/Home/ListRegisteredStudentsAuca/StudentsTable";

import { mapGetters } from "vuex";
export default {
    components:{
        StudentsTable,

    },
    data() {
        return {
            loading: false,
            courseInfo: null,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6,
            },
            listStudents: [],
            notificationListStudents: []
        };
    },
    computed: {
        ...mapGetters({
            GET_WAITING_LIST_SETTINGS: 'system_settings/GET_WAITING_LIST_SETTINGS',
        }),
        windowWidth() {
            return this.$store.state.windowWidth;
        },
        useNotificationList(){
            return this.GET_WAITING_LIST_SETTINGS.use_waiting_list
        },
    },
    async created() {
        await this.setCourseInfo();
        await this.getStudents();
        await this.getNotificationListStudents()
        if (this.GET_WAITING_LIST_SETTINGS === null){
            await this.$store.dispatch('system_settings/getWaitingListSettings')
        }
        this.$route.meta.pageTitle = ''
        this.$route.meta.pageTitle = this.$t('students-list')
    },

    methods: {
        // инфа о текущем курсе
        async setCourseInfo() {
            this.$vs.loading();
            this.courseInfo = (
                await this.$http.get('organizations/teachers_discipline/course_info/', { params: this.$route.query })
            ).data
            this.$vs.loading.close();
        },
        // Получение списка студентов с параметрами из url
        async getStudents() {
            this.$vs.loading();
            this.listStudents = (
                await this.$http.get(`organizations/students_list/`, { params: this.$route.query })
            ).data.results;
            this.$vs.loading.close();
        },
        async getNotificationListStudents() {
            this.$vs.loading();
            let query = Object.assign({}, this.$route.query)
            query.tab = 'notification_list'
            this.notificationListStudents = (
                await this.$http.get(`organizations/students_list/`, { params: query })
            ).data.results;
            this.$vs.loading.close();
        },
        // Переходим на profile студента
        goToProfile(data)  {
            // Открыть в новой вкладке
            const routeData = this.$router.resolve({
                name: "students-list-view",
                query: { uid: data.student.uid, full_name: data.student.full_name, student_id: data.student.student_id}});
            window.open(routeData.href);
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
.emc__actions {
    .con-vs-tabs {
        padding-bottom: 2px;
        width: auto;
    }
    .con-slot-tabs {
        display: none;
    }
}
.emc_list_tabs {
    .con-ul-tabs {
        display: none;
    }
    .vs-tabs--content {
        padding: 0px;
    }
}
.filters_scroll_area {
    position: relative;
    width: 100%;
    margin: auto;
    &.aside_scroll_teacher {
        height: calc(100% - 67px);
    }
    &:not(.aside_scroll_teacher) {
        height: 100%;
    }
}
.infinite_scroll_wrapper {
    margin: auto;
    position: relative;
    width: 100%;
    height: calc(100% - 50px);
    .infinite_alert {
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
        text-align: center;
    }
}
#infinite_loader {
    padding: 20px 0;
    .con-vs-loading {
        background: transparent;
    }
}
.full-vs-sidebar {
    .mail-sidebar-content {
        background-color: rgb(248, 248, 248) !important;
    }
    .email-header {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04);
        border-bottom: 1px solid #eee;
    }
}
.todo__filters-container {
    .multiselect__single {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
.cursor {
    cursor:pointer;
}
</style>
